import DocumentFlow from "../../../../domains/documentFlow/documentFlow";
import { MoreOptionsOnGivenHook } from "../../../menu/menu2";
import clsx from "clsx";
import * as React from "react";
import { useStyles } from "./docFlowTableRelated.styles";
import { DocumentFlowService } from "../../../../domains/documentFlow/documentFlow.service";
import { UserInteractionType } from "../../../../../shared/domains/user/userInteractionType";
import { NbsSapScopeData } from "src/app/nbsCockpit/interfaces/nbs";
import { MrpUser } from "src/app/shared/domains/user/user";
import { useSelector } from "react-redux";
import { RootStateStore } from "src/app/application.reducers";
import { FeaturesContext } from "src/app/shared/domains/core/pataflag.context";
import { Features } from "src/app/shared/domains/core/pataflag";
import { useCreateFairmrktRfq } from "src/app/docFlows/hooks/docflow.hooks";
import Notification, {
  NotificationType
} from "src/app/shared/components/notification";
import { Portal } from "@material-ui/core";
import { getErrorMessage } from "../../../itemDrilldownTable/ItemDrilldownMenuComponent";
import { getTheNewPrUrl } from "src/app/shared/helpers/functions";

export const compCodes = [
  "UA15",
  "UA14",
  "UA12",
  "UA11",
  "UA10",
  "RU44",
  "RU37",
  "RU19",
  "RU12",
  "RO10",
  "PT24",
  "PT10",
  "PL33",
  "PL16",
  "PL10",
  "GB19",
  "FR66",
  "FR57",
  "FR54",
  "FR49",
  "FR47",
  "FR46",
  "FR45",
  "FR0Y",
  "FR0W",
  "DE21",
  "BE31",
  "BE14",
  "CH30",
  "NL10",
  "BE12",
  "LT12",
  "KZ11",
  "IT39",
  "IT38",
  "IT15",
  "IT11",
  "IE25",
  "IE24",
  "IE10",
  "SI11",
  "RS10",
  "MK10",
  "HR11",
  "BA10",
  "GR18",
  "GR10",
  "GB95",
  "GB23",
  "GB21",
  "GB12",
  "GB0D",
  "GB0B",
  "FR80",
  "FR78",
  "FR65",
  "FR58",
  "FR42",
  "FR41",
  "FR29",
  "FR20",
  "FR1A",
  "FR15",
  "FR13",
  "FR12",
  "FR10",
  "ES42",
  "ES21",
  "ES13",
  "ES10",
  "SE16",
  "NO10",
  "FI11",
  "DK12",
  "DE66",
  "DE64",
  "DE60",
  "DE55",
  "DE52",
  "DE2I",
  "DE13",
  "DE10",
  "DE0K",
  "CH0W",
  "CH0P",
  "CH85",
  "CH82",
  "CH27",
  "CH20",
  "CH17",
  "CH12",
  "CH11",
  "CH0Z",
  "BY10",
  "BG10",
  "AT10",
  "ZW11",
  "ZA10",
  "MU14",
  "KE12",
  "VN10",
  "TR17",
  "TR13",
  "TR10",
  "TH22",
  "TH19",
  "TH18",
  "TH17",
  "TH16",
  "TH15",
  "TH14",
  "TH13",
  "TH12",
  "TH11",
  "TH10",
  "SG28",
  "SG27",
  "SG23",
  "SG12",
  "PK10",
  "PH26",
  "PH24",
  "PH15",
  "PH11",
  "NZ11",
  "MY42",
  "MY40",
  "MY39",
  "MY38",
  "MY37",
  "MY36",
  "MY34",
  "MY33",
  "MM11",
  "MM10",
  "TN11",
  "TN10",
  "MA12",
  "MA10",
  "DZ12",
  "DZ11",
  "ZM10",
  "KE10",
  "JP21",
  "IN14",
  "IN12",
  "SN10",
  "NG10",
  "GH11",
  "GH10",
  "GA10",
  "CM10",
  "CI14",
  "CI11",
  "BF10",
  "AO13",
  "AO12",
  "EG10",
  "CN3T",
  "CN37",
  "BD10",
  "AU11",
  "SA17",
  "QA11",
  "PS10",
  "OM10",
  "LB12",
  "KW10",
  "JO11",
  "BH11",
  "AE18",
  "AE17",
  "AE12",
  "AE10",
  "UY10",
  "US9B",
  "US9A",
  "US8X",
  "US5Z",
  "US5C",
  "US22",
  "US16",
  "US10",
  "US0L",
  "SK10",
  "US1I",
  "PY14",
  "PY12",
  "PE15",
  "PE10",
  "US0X",
  "SV10",
  "PA26",
  "PA20",
  "PA19",
  "PA12",
  "NI10",
  "MX32",
  "HN10",
  "GT18",
  "GT13",
  "GT12",
  "GT10",
  "CR13",
  "CR10",
  "GB11",
  "MX38",
  "MX30",
  "MX29",
  "MX27",
  "MX23",
  "MX21",
  "MX20",
  "MX19",
  "MX18",
  "MX14",
  "MX13",
  "MX10",
  "LK12",
  "ID18",
  "ID16",
  "ID10",
  "HU17",
  "HU10",
  "FR97",
  "FR1N",
  "EC14",
  "EC13",
  "EC12",
  "TT10",
  "PA17",
  "JM11",
  "DO12",
  "CZ16",
  "CZ11",
  "CO18",
  "CO17",
  "CO16",
  "CO13",
  "CO11",
  "CL11",
  "CL10",
  "CH1A",
  "CH0X",
  "CA30",
  "CA10",
  "BO10",
  "AR12",
  "US39",
  "CA23"
];

export const doWeNeedUrl = (value: string) => {
  console.log(process.env.REACT_APP_ENV.trim());
  const tempVal =
    (process.env.REACT_APP_ENV.trim() === "dev" ||
      process.env.REACT_APP_ENV.trim() === "local") &&
    value?.substring(0, 2)?.toUpperCase() === "Y2";
  return tempVal;
};

export const doWeNeedRteUrl = (zone: string) => {
  console.log(process.env.REACT_APP_ENV.trim());
  const tempVal =
    process.env.REACT_APP_ENV.trim() === "rte" &&
    zone?.toUpperCase() === "R3AO1";
  return tempVal;
};

export const doWeNeedPpdUrl = (zone: string) => {
  console.log(process.env.REACT_APP_ENV.trim());
  console.log(zone);
  const tempVal =
    process.env.REACT_APP_ENV.trim() === "test" &&
    (zone?.toUpperCase() === "R3AO1" ||
      zone?.toUpperCase() === "R3AO1_PS" ||
      zone?.toUpperCase() === "");
  return tempVal;
};

export const doWeNeedProdUrl = (zone: string) => {
  console.log(process.env.REACT_APP_ENV.trim())
  console.log(zone)
  const tempVal = ((process.env.REACT_APP_ENV.trim() === "prod"));
  return tempVal
}

export const getPpdZonebasedUrl = (
  zone: any,
  newPpdAoaPRUrl,
  newPpdAoaPsPRUrl
) => {
  console.log(zone);
  let finalUrl;
  if (zone?.toUpperCase() === "R3AO1") {
    console.log("AOA");
    finalUrl = newPpdAoaPRUrl;
  }
  if (zone?.toUpperCase() === "R3AO1_PS" || zone === "") {
    console.log("AOA_PS");
    finalUrl = newPpdAoaPsPRUrl;
  }
  return finalUrl;
};

export const PRLink = ({
  documentFlow: df,
  toggleItems,
  canEdit
}: {
  documentFlow: DocumentFlow;
  toggleItems;
  canEdit;
}) => {
  const classes = useStyles({});
  const mrpUser: MrpUser = useSelector((state: RootStateStore) =>
    MrpUser.fromUser(state.shared.user.currentUser)
  );
  const isBuyer = mrpUser.isAtMarket() || mrpUser.isAboveMarket();
  const { hasFeature } = React.useContext(FeaturesContext);

  const {
    mutateAsync: initialRfq,
    error: initiateRfqError,
    isSuccess: isInitiateRfqSuccess,
    isError: isInitiateRfqError
  } = useCreateFairmrktRfq();

  const prWorkFlow =
    "https://nestle.service-now.com/sp?id=sc_cat_item&sys_id=a018221697bc91108996b31de053afe4&sysparm_domain_restore=false&sysparm_stack=no";
  const prOwnership =
    "https://nestle.service-now.com/sp?id=sc_cat_item&sys_id=942db1e3973c19508996b31de053afc6&sysparm_domain_restore=false&sysparm_stack=no";

  const newPrUrl =
    "https://globe7dev.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpdev.nestle.com:52802/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
    df?.PurchaseReqNo;

  const newRtePRUrl =
    "https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoarte.nestle.com:55802/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
    df?.PurchaseReqNo;

  const newPpdAoaPRUrl =
    "https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
    df?.PurchaseReqNo;

  const newPpdAoaPsPRUrl =
    "https://globe7eurprep.nestle.com:26001/irj/servlet/prt/portal/prtroot/pcd!3a!2f!2fportal_content!2ftemplates!2fiviews!2fsap_transaction_iview?System=R3AO1&TCode=/GLB/RGTPP01_ME53N&GuiType=WinGui&SAP_TransType=TXN&SAP_TechRoleName=CONTROL2007&SAP_Market=XXSAP_DummySystem=&SAP_Source=EXT&SAP_IViewDesc=ME33K&DynamicParameter=P_BANFN%3d" +
    df?.PurchaseReqNo +
    "%26&AutoStart=true&noIEModeReentrant=true";

  // const menuItems = [
  //   // {label: "Details", onClick: toggleItems, visible: true},
  //   {
  //     label: "View in SAP",
  //     onClick: async () => {
  //       if (hasFeature(Features.S2P_174839_ENABLE_S4HANA_PPD_URLS_FOR_08A_0XA) || hasFeature(Features.S2P_177047_ENABLE_S4HANA_PROD_URLS_FOR_09A)) 
  //       {
  //         window.open(
  //           doWeNeedUrl(DocumentFlow.getCompanyCode(df)) ?
  //             newPrUrl : doWeNeedRteUrl(df.SystemAlias) ?
  //               newRtePRUrl : doWeNeedPpdUrl(df.SystemAlias) ?
  //                 getPpdZonebasedUrl(
  //                   df.SystemAlias,
  //                   newPpdAoaPRUrl,
  //                   newPpdAoaPsPRUrl
  //                 ) : doWeNeedProdUrl(df.SystemAlias) ? 
  //                   getTheNewPrUrl(df.SystemAlias,df?.PurchaseReqNo,df.ViewPRSAPLink, hasFeature) : df.ViewPRSAPLink, "_blank");
  //       } else if (hasFeature(Features.S2P_178151_ENABLE_S4HANA_RTE_URLS_FOR_E7B) || hasFeature(Features.S2P_179278_ENABLE_S4HANA_PPD_URLS_FOR_E8A)){
  //         window.open(getTheNewPrUrl(df.SystemAlias,df?.PurchaseReqNo,df.ViewPRSAPLink, hasFeature), '_blank');
  //       } else {
  //         window.open(
  //           doWeNeedUrl(DocumentFlow.getCompanyCode(df))
  //             ? newPrUrl
  //             : doWeNeedRteUrl(df.SystemAlias)
  //             ? newRtePRUrl
  //             : df.ViewPRSAPLink,
  //           "_blank"
  //         );
  //       }
  //       await DocumentFlowService.logUserInteractionData(
  //         UserInteractionType.ViewedInSAPRequestCockpitPR
  //       );
  //     },
  //     visible: true
  //   }
  // ];

  const menuItems = [
    {
      label: "View in SAP",
      onClick: async () => {

        // ✅ STEP 1: Try NEW logic (Stories 180784 & 180874)
        const newUrl = getTheNewPrUrl(
          df.SystemAlias,
          df?.PurchaseReqNo,
          df.ViewPRSAPLink,
          hasFeature
        );

        // ✅ STEP 2: If new logic changed URL → use it
        if (newUrl && newUrl !== df.ViewPRSAPLink) {
          console.log("Using NEW URL:", newUrl);
          window.open(newUrl, "_blank");
        } else {
          // ✅ STEP 3: fallback to OLD logic (unchanged)
          console.log("Using OLD logic");

          const fallbackUrl =
            doWeNeedUrl(DocumentFlow.getCompanyCode(df))
              ? newPrUrl
              : doWeNeedRteUrl(df.SystemAlias)
                ? newRtePRUrl
                : doWeNeedPpdUrl(df.SystemAlias)
                  ? getPpdZonebasedUrl(
                    df.SystemAlias,
                    newPpdAoaPRUrl,
                    newPpdAoaPsPRUrl
                  )
                  : df.ViewPRSAPLink;

          window.open(fallbackUrl, "_blank");
        }

        await DocumentFlowService.logUserInteractionData(
          UserInteractionType.ViewedInSAPRequestCockpitPR
        );
      },
      visible: true
    }
  ];
  let hasMoreOptions = (df.DocType || "").trim().indexOf("ZARB") === 0;
  if (df.AribaReqNum) {
    menuItems.push({
      label: "View Approval Status",
      onClick: async () => {
        // US - 159430
        // check for whether PR is Easy ReqPR or not?

        let isEasyReqPR = false;
        if (df.AribaPR === "" && !!df.AribaReqNum) {
          isEasyReqPR = true;
        } else isEasyReqPR = false;

        window.open(
          `/approval-status?AribaPR=${df.AribaReqNum}&isEasyReqPR=${isEasyReqPR}&PoNo=${df.PurchaseOrdNo}`,
          "_blank"
        );
        await DocumentFlowService.logUserInteractionData(
          UserInteractionType.ViewPRApprovalStatus
        );
      },
      visible: true
    });
  }
  if (hasMoreOptions) {
    menuItems.push({
      label: "View in Easy Buy",
      onClick: async () => {
        window.open(df.ViewPREBLink, "_blank");
        await DocumentFlowService.logUserInteractionData(
          UserInteractionType.ViewedInEasyBuyRequestCockpitPR
        );
      },
      visible: true
    });
    if (!compCodes.includes(df.POCompanyCode)) {
      menuItems.push({
        label: "Update PR Workflow",
        onClick: async () => {
          window.open(prWorkFlow, "_blank");
          await DocumentFlowService.logUserInteractionData(
            UserInteractionType.UpdatePRWorkflow
          );
        },
        visible: true
      });
    }

    menuItems.push({
      label: "Update PR Ownership",
      onClick: async () => {
        window.open(prOwnership, "_blank");
        await DocumentFlowService.logUserInteractionData(
          UserInteractionType.UpdatePROwnership
        );
      },
      visible: true
    });
  }
  if (isBuyer && hasFeature(Features.MRP_FAIRMRKT_INITIATE_RFQ_168423)) {
    menuItems.push({
      label: "Initiate RFQ",
      onClick: async () => {
        await initialRfq({ prNo: df.PurchaseReqNo });
      },
      visible: true
    });
  }

  return (
    <>
      <MoreOptionsOnGivenHook items={menuItems}>
        <span className={clsx(classes.link, classes.text)}>
          {df.AribaPR ? df.AribaPR : df.PurchaseReqNo.replace(/^0+/, "")}
        </span>
      </MoreOptionsOnGivenHook>
      {isInitiateRfqError && (
        <Portal>
          <Notification
            type={NotificationType.error}
            message={getErrorMessage(initiateRfqError)}
          />
        </Portal>
      )}
      {isInitiateRfqSuccess && (
        <Portal>
          <Notification
            type={NotificationType.success}
            message={`RFQ initiated sucessfully for PR ${df.PurchaseReqNo}`}
          />
        </Portal>
      )}
    </>
  );
};

// export const SapScopePRLink = ({
//   nbsSapScope: data
// }: {
//   nbsSapScope: NbsSapScopeData;
// }) => {
//   const { hasFeature } = React.useContext(FeaturesContext);

//   const zone = useSelector(
//     (state: RootStateStore) => state.docFlows.documentFlows.data.selectedZone
//   );

//   const classes = useStyles({});
//   const newPrUrl =
//     "https://globe7dev.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpdev.nestle.com:52802/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
//     data?.PurchaseReqNo;
//   const newRtePRUrl =
//     "https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoarte.nestle.com:55802/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
//     data?.PurchaseReqNo;
//   const newPpdAoaPRUrl =
//     "https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
//     data?.PurchaseReqNo;
//   const newPpdAoaPsPRUrl =
//     "https://globe7eurprep.nestle.com:26001/irj/servlet/prt/portal/prtroot/pcd!3a!2f!2fportal_content!2ftemplates!2fiviews!2fsap_transaction_iview?System=R3AO1&TCode=/GLB/RGTPP01_ME53N&GuiType=WinGui&SAP_TransType=TXN&SAP_TechRoleName=CONTROL2007&SAP_Market=XXSAP_DummySystem=&SAP_Source=EXT&SAP_IViewDesc=ME33K&DynamicParameter=P_BANFN%3d" +
//     data?.PurchaseReqNo +
//     "%26&AutoStart=true&noIEModeReentrant=true";

//   const menuItems = [
//     {
//       label: "View in SAP",onClick: () => {
//         if (hasFeature(Features.S2P_174839_ENABLE_S4HANA_PPD_URLS_FOR_08A_0XA) || hasFeature(Features.S2P_177047_ENABLE_S4HANA_PROD_URLS_FOR_09A)) {
//           window.open(
//             doWeNeedUrl((data.PRCompanyCode && data.PRCompanyCode !== "") ? data.PRCompanyCode: data.POCompanyCode) ?
//               newPrUrl : doWeNeedRteUrl(data?.SystemAlias) ?
//                 newRtePRUrl : doWeNeedPpdUrl(data?.SystemAlias) ?
//                   getPpdZonebasedUrl(data?.SystemAlias, newPpdAoaPRUrl, newPpdAoaPsPRUrl) : doWeNeedProdUrl(data?.SystemAlias) ? 
//                     getTheNewPrUrl(data?.SystemAlias,data?.PurchaseReqNo,data.ViewPRSAPLink, hasFeature): data.ViewPRSAPLink,"_blank"
//           );
//         } else if (hasFeature(Features.S2P_178151_ENABLE_S4HANA_RTE_URLS_FOR_E7B) || hasFeature(Features.S2P_179278_ENABLE_S4HANA_PPD_URLS_FOR_E8A)){
//           window.open(getTheNewPrUrl(data?.SystemAlias,data?.PurchaseReqNo,data.ViewPRSAPLink, hasFeature), '_blank');
//         } else {
//           window.open(
//             doWeNeedUrl((data.PRCompanyCode && data.PRCompanyCode !== "") ? data.PRCompanyCode : data.POCompanyCode) ?
//               newPrUrl : doWeNeedRteUrl(data?.SystemAlias) ?
//                 newRtePRUrl : data.ViewPRSAPLink, "_blank"
//           );
//         }

//         // window.open(
//         //   doWeNeedUrl(
//         //     data.PRCompanyCode && data.PRCompanyCode !== ""
//         //       ? data.PRCompanyCode
//         //       : data.POCompanyCode
//         //   )
//         //     ? newPrUrl
//         //     : data.ViewPRSAPLink,
//         //   "_blank"
//         // );

//         // await DocumentFlowService.logUserInteractionData(UserInteractionType.ViewedInSAPRequestCockpitPR);
//       },visible: true
//     }
//   ];

//   return (
//     <MoreOptionsOnGivenHook items={menuItems}>
//       <span className={clsx(classes.link, classes.text)}>
//         {data.AribaPR ? data.AribaPR : data.PurchaseReqNo.replace(/^0+/, "")}
//       </span>
//     </MoreOptionsOnGivenHook>
//   );
// };
export const SapScopePRLink = ({
  nbsSapScope: data
}: {
  nbsSapScope: NbsSapScopeData;
}) => {
  const { hasFeature } = React.useContext(FeaturesContext);

  const zone = useSelector(
    (state: RootStateStore) => state.docFlows.documentFlows.data.selectedZone
  );

  const classes = useStyles({});

  const newPrUrl =
    "https://globe7dev.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpdev.nestle.com:52802/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
    data?.PurchaseReqNo;

  const newRtePRUrl =
    "https://globe7rte.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoarte.nestle.com:55802/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
    data?.PurchaseReqNo;

  const newPpdAoaPRUrl =
    "https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpaoaprep.nestle.com:55801/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
    data?.PurchaseReqNo;

  const newPpdAoaPsPRUrl =
    "https://globe7eurprep.nestle.com:26001/irj/servlet/prt/portal/prtroot/pcd!3a!2f!2fportal_content!2ftemplates!2fiviews!2fsap_transaction_iview?System=R3AO1&TCode=/GLB/RGTPP01_ME53N&GuiType=WinGui&SAP_TransType=TXN&SAP_TechRoleName=CONTROL2007&SAP_Market=XXSAP_DummySystem=&SAP_Source=EXT&SAP_IViewDesc=ME33K&DynamicParameter=P_BANFN%3d" +
    data?.PurchaseReqNo +
    "%26&AutoStart=true&noIEModeReentrant=true";

  const menuItems = [
    {
      label: "View in SAP",
      onClick: () => {
        // ✅ STEP 1: NEW LOGIC (Stories 180784 & 180874)
        const newUrl = getTheNewPrUrl(
          data?.SystemAlias,
          data?.PurchaseReqNo,
          data.ViewPRSAPLink,
          hasFeature
        );

        if (newUrl && newUrl !== data.ViewPRSAPLink) {
          console.log("Using NEW URL:", newUrl);
          window.open(newUrl, "_blank");
          return;
        }

        // ✅ STEP 2: OLD LOGIC (UNCHANGED)
        console.log("Using OLD logic");

        if (
          hasFeature(Features.S2P_174839_ENABLE_S4HANA_PPD_URLS_FOR_08A_0XA) ||
          hasFeature(Features.S2P_177047_ENABLE_S4HANA_PROD_URLS_FOR_09A)
        ) {
          window.open(
            doWeNeedUrl(
              data.PRCompanyCode && data.PRCompanyCode !== ""
                ? data.PRCompanyCode
                : data.POCompanyCode
            )
              ? newPrUrl
              : doWeNeedRteUrl(data?.SystemAlias)
                ? newRtePRUrl
                : doWeNeedPpdUrl(data?.SystemAlias)
                  ? getPpdZonebasedUrl(
                    data?.SystemAlias,
                    newPpdAoaPRUrl,
                    newPpdAoaPsPRUrl
                  )
                  : data.ViewPRSAPLink,
            "_blank"
          );
        } else if (
          hasFeature(Features.S2P_178151_ENABLE_S4HANA_RTE_URLS_FOR_E7B) ||
          hasFeature(Features.S2P_179278_ENABLE_S4HANA_PPD_URLS_FOR_E8A)
        ) {
          window.open(
            getTheNewPrUrl(
              data?.SystemAlias,
              data?.PurchaseReqNo,
              data.ViewPRSAPLink,
              hasFeature
            ),
            "_blank"
          );
        } else {
          window.open(
            doWeNeedUrl(
              data.PRCompanyCode && data.PRCompanyCode !== ""
                ? data.PRCompanyCode
                : data.POCompanyCode
            )
              ? newPrUrl
              : doWeNeedRteUrl(data?.SystemAlias)
                ? newRtePRUrl
                : data.ViewPRSAPLink,
            "_blank"
          );
        }
      },
      visible: true
    }
  ];

  return (
    <MoreOptionsOnGivenHook items={menuItems}>
      <span className={clsx(classes.link, classes.text)}>
        {data.AribaPR
          ? data.AribaPR
          : data.PurchaseReqNo.replace(/^0+/, "")}
      </span>
    </MoreOptionsOnGivenHook>
  );
};
export const RfqIdLink = ({ docFlow }: { docFlow: DocumentFlow }) => {
  const classes = useStyles({});

  const menuItems = [
    {
      label: "View in Fairmarkt",
      onClick: () => {
        window.open(docFlow.RFQLink, "_blank");
      },
      visible: true
    }
  ];

  return (
    <MoreOptionsOnGivenHook items={menuItems}>
      <span className={clsx(classes.link, classes.text)}>{docFlow.RFQId}</span>
    </MoreOptionsOnGivenHook>
  );
};

export const InvoiceLink = ({
  actionType = 0,
  docType = "",
  sapLink,
  aribaLink = "",
  aribaPr = "",
  data
}) => {
  const classes = useStyles({});

  const menuItems = [
    {
      label: "View in SAP",
      onClick: async () => {
        window.open(sapLink, "_blank");
        await DocumentFlowService.logUserInteractionData(actionType);
      },
      visible: true
    }
  ];
  let hasMoreOptions = (docType || "").trim().indexOf("ZARB") === 0;
  if (hasMoreOptions) {
    menuItems.push({
      label: "View in Easy Buy",
      onClick: async () => {
        window.open(aribaLink, "_blank");
        await DocumentFlowService.logUserInteractionData(
          UserInteractionType.ViewedInEasyBuyRequestCockpitInvoice
        );
      },
      visible: true
    });
  }

  return (
    <MoreOptionsOnGivenHook items={menuItems}>
      <span className={clsx(classes.link, classes.text)}>
        {aribaPr ? aribaPr : data?.replace(/^0+/, "")}
      </span>
    </MoreOptionsOnGivenHook>
  );
};

export const BALink = ({
  aribaLink = "",
  aribaPr = "",
  sapLink = "",
  sapPr = "",
  systemAlias = ""
}) => {
  const classes = useStyles({});
  const menuItems = [];

  const systemAliasUpper = systemAlias?.toUpperCase();
  const isProdEuropeZone =
    systemAliasUpper === "R3AE1" ||
    systemAliasUpper === "R3AE1_PS";

  const newPpdViewPrUrl = isProdEuropeZone
    ? "https://globe7.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeur.nestle.com:55801/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
      sapPr
    : "https://globe7prep.nestle.com/irj/servlet/prt/portal/prtroot/com.nestle.globe.ep7core.xx.redirect.Redirect_window?REDIRECTURL=https://erpeurprep.nestle.com:55801/launchpad%23RGTPP01_ME53N-execute%3FP_BANFN%3d" +
      sapPr;

  const shouldUseLaunchpadUrl =
    doWeNeedPpdUrl(systemAlias) ||
    isProdEuropeZone;

  if (sapPr && sapLink) {
    menuItems.push({
      label: "View in SAP",
      onClick: async () => {
        window.open(
          shouldUseLaunchpadUrl ? newPpdViewPrUrl : sapLink,
          "_blank"
        );
      },
      visible: true
    });
  }

  if (aribaPr && aribaLink) {
    menuItems.push({
      label: "View in Easy Buy",
      onClick: async () => {
        window.open(aribaLink, "_blank");
      },
      visible: true
    });
  }

  return (
    <MoreOptionsOnGivenHook items={menuItems}>
      {sapPr && sapLink && (
        <span className={clsx(classes.link, classes.text)}>
          {sapPr.replace(/^0+/, "")}
        </span>
      )}
      {aribaPr && aribaLink && (
        <span className={clsx(classes.link, classes.text)}>
          {aribaPr.replace(/^0+/, "")}
        </span>
      )}
    </MoreOptionsOnGivenHook>
  );
};
